module.exports = "<div class=\"wrapper\">\n\n  <app-header></app-header>\n\n  <div id=\"wrapper\" *ngIf=\"authService.loggedIn()\">\n       <!-- Left side column. contains the logo and sidebar -->\n      <app-sidebar></app-sidebar>\n\n      <!-- contains the main data -->\n     <div id=\"content\">\n          <flash-messages></flash-messages>\n          <router-outlet></router-outlet>\n          <app-footer></app-footer>\n     </div>\n  </div>\n  <div id=\"wrapper\" *ngIf=\"!authService.loggedIn()\">\n       <app-login></app-login>\n       <app-footer></app-footer>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 404
// module chunks = 1